import { useLocation } from 'react-router-dom';
import { LogoutOutlined, StarOutlined, UserOutlined } from '@ant-design/icons';
import { useAuth0 } from '@auth0/auth0-react';
import { Col, Layout, Menu as AntdMenu, Row } from 'antd';

import { MilesText } from 'components';

import { commonStore } from 'stores';
import { useLogout } from 'hooks';
import { isUserAdmin } from 'utils';

import { menuItems } from './menuHelpers';
import { StartCorrection } from './StartCorrection';

import './Menu.styles.scss';

const { Sider } = Layout;

export const Menu = () => {
  const authUser = commonStore((state) => state.user);

  const { user } = useAuth0();
  const { pathname, search } = useLocation();

  const [handleLogout] = useLogout();

  const [path] = pathname.split('/').filter(Boolean);

  const isAdmin = isUserAdmin(authUser?.role);

  if (user) {
    return (
      <Sider
        collapsible
        theme='light'
      >
        <Row
          align='middle'
          className='h-[64px] px-[25px] bg-[#001529] relative'
        >
          <img
            width={30}
            height={30}
            alt='Logo'
            src='/images/logo.svg'
            className='mr-[15px]'
          />

          <MilesText
            strong
            textWhite
            size='lg'
            className='logo-text'
          >
            AirMiles
          </MilesText>
        </Row>

        <div className='h-[calc(100%-64px)] flex flex-col justify-between'>
          <AntdMenu
            mode='inline'
            items={menuItems(path, search, isAdmin)}
            selectedKeys={[path || 'offers']}
          />

          <Row>
            <Col xs={24}>
              <Row justify='center'>
                <StartCorrection />
              </Row>

              <Row>
                <button
                  type='button'
                  className='menu-user-action'
                >
                  {isAdmin
                    ? <StarOutlined title={authUser?.role} />
                    : <UserOutlined title={authUser?.role} />}

                  <span>{authUser?.name}</span>
                </button>
              </Row>

              <Row>
                <button
                  type='button'
                  className='menu-user-action'
                  onClick={handleLogout}
                >
                  <LogoutOutlined rotate={180} />

                  <span>Logout</span>
                </button>
              </Row>
            </Col>
          </Row>
        </div>
      </Sider>
    );
  }

  return null;
};
